import './styles.css'
import React from 'react'
import { Message, TransitionablePortal, Icon } from 'semantic-ui-react'
import { useDispatch } from 'react-redux'
import createAction from '../../../../../../redux/actions/createAction'
import { HIDE_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE } from '../../../../../../redux/actions/actionTypes'

const portalStyle = {
  position: 'fixed',
  top: 16,
  right: '50%',
  transform: 'translateX(50%)',
  zIndex: 1000,
  maxWidth: 420,
}

const AUTO_DISMISS_MS = 3000

function BookingsGeneralNotificationMessage(props) {
  const { isShowing, header, content, isError } = props
  const resetNotificationMessageState = React.useRef(null)
  const [animationKey, setAnimationKey] = React.useState(0)
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!isShowing) return
    // Restart the progress bar animation every time we show the toast
    setAnimationKey(prev => prev + 1)
    // eslint-disable-next-line consistent-return
    if (resetNotificationMessageState.current) clearTimeout(resetNotificationMessageState.current)
    resetNotificationMessageState.current = setTimeout(() => {
      resetNotificationMessageState.current = null
      dispatch(createAction(HIDE_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE))
    }, AUTO_DISMISS_MS)
    // eslint-disable-next-line consistent-return
    return () => {
      if (resetNotificationMessageState.current) clearTimeout(resetNotificationMessageState.current)
    }
  }, [isShowing, dispatch])

  const handleNotificationClose = () => {
    if (resetNotificationMessageState.current) clearTimeout(resetNotificationMessageState.current)
    dispatch(createAction(HIDE_BOOKINGS_GENERAL_NOTIFICATION_MESSAGE))
    resetNotificationMessageState.current = null
  }

  return (
    <TransitionablePortal
      open={isShowing}
      transition={{ animation: 'fade', duration: 300 }}
      onClose={() => handleNotificationClose()}
    >
      <div style={portalStyle}>
        <Message
          className="bookings-notification-message"
          {...(isError ? { negative: true } : { positive: true })}
          onDismiss={() => handleNotificationClose()}
        >
          <div className="bookings-notification-message__content">
            <div className="bookings-notification-message__header">
              <Icon name={isError ? 'times circle' : 'check circle'} />
              <h4>{header}</h4>
            </div>
            <p>{content}</p>
          </div>
          <div className="bookings-notification-message__progress">
            <div
              key={animationKey}
              className={`bookings-notification-message__progress-bar ${
                isError
                  ? 'bookings-notification-message__progress-bar--error'
                  : 'bookings-notification-message__progress-bar--success'
              }`}
              style={{ animationDuration: `${AUTO_DISMISS_MS}ms` }}
            />
          </div>
        </Message>
      </div>
    </TransitionablePortal>
  )
}

export default React.memo(BookingsGeneralNotificationMessage)
